import React, { useState } from "react";
import { Table, Form, Button, Modal } from "react-bootstrap";
import { FaTrash, FaDownload } from "react-icons/fa";
import WebTranslations from "./language-designs/WebTranslations";
import AppTranslations from "./language-designs/AppTranslations";
import AdminTranslations from "./language-designs/AdminTranslations";

const Language = () => {
  const [view, setView] = useState("list");
  const [showDelete, setShowDelete] = useState(false);
  const [selectedLang, setSelectedLang] = useState(null);

  const languages = [
    { name: "English", code: "en", progress: 80, done: 1296 },
    { name: "Arabic", code: "ar", progress: 50, done: 810 },
    { name: "German", code: "de", progress: 70, done: 972 },
    { name: "French", code: "fr", progress: 20, done: 324 },
  ];

  return (
    <div className="language-page">
      <h5 className="mb-3">Language</h5>

      {/* HEADER */}
      {view === "list" && (
        <div className="d-flex justify-content-between mb-3 flex-wrap gap-2">
          <div></div>

          <div className="d-flex gap-2">
            <Form.Select className="w-auto">
              <option>Select Language</option>
              <option>English</option>
              <option>Arabic</option>
            </Form.Select>

            <Button className="btn-orange" onClick={() => setView("translation")}>
              Add Language
            </Button>
          </div>
        </div>
      )}

      <div className="section-border">

        {/* ================= LIST ================= */}
        {view === "list" && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <h6>Language List</h6>
              <Form.Control placeholder="Search" style={{ maxWidth: 250 }} />
            </div>

            <Table responsive className="align-middle language-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Language</th>
                  <th>Code</th>
                  <th>RTL</th>
                  <th>Default</th>
                  <th>Total</th>
                  <th>Done</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {languages.map((lang, i) => (
                  <tr key={i}>
                    <td>
                      <Form.Check defaultChecked={i === 0} />
                    </td>

                    {/* FLAG + NAME */}
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={`/assets/flags/${lang.code}.png`}
                          className="flag-icon"
                          alt=""
                        />
                        {lang.name}
                      </div>
                    </td>

                    <td>{lang.code}</td>

                    <td><Form.Check type="switch" /></td>

                    <td><Form.Check type="switch" defaultChecked={i === 0} /></td>

                    <td>1620</td>
                    <td>{lang.done}</td>

                    {/* PROGRESS */}
                    <td>
                      <div className="progress-ring-wrapper">
                        <svg width="36" height="36">
                          <circle cx="18" cy="18" r="15" className="progress-bg" />
                          <circle
                            cx="18"
                            cy="18"
                            r="15"
                            className={`progress-fill progress-${lang.code}`}
                            strokeDasharray="94"
                            strokeDashoffset={94 - (94 * lang.progress) / 100}
                          />
                        </svg>
                        <span>{lang.progress}%</span>
                      </div>
                    </td>

                    <td><Form.Check type="switch" /></td>

                    {/* ACTION */}
                    <td className="d-flex gap-2 flex-wrap">
                   <div  className="action-group" >
                       <Button className="icon-btn" size="sm" variant="light">
                        <FaDownload />
                      </Button>

                      <Button size="sm" variant="light" onClick={() => setView("web")}>
                        Web
                      </Button>

                      <Button size="sm" variant="light" onClick={() => setView("app")}>
                        App
                      </Button>

                      <Button size="sm" variant="light" onClick={() => setView("admin")}>
                        Admin
                      </Button>

                      <Button className="icon-btn"
                        size="sm"
                        variant="light"
                        onClick={() => {
                          setSelectedLang(lang);
                          setShowDelete(true);
                        }}
                      >
                        <FaTrash />
                      </Button>
                   </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {/* ================= TRANSLATION ================= */}
        {view === "translation" && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <Button className="btn-orange" onClick={() => setView("list")}>
                ← Back to Translations
              </Button>

              <span className="badge bg-light text-dark">Arabic</span>
            </div>

            <Table>
              <thead>
                <tr>
                  <th>English</th>
                  <th>Arabic</th>
                </tr>
              </thead>

              <tbody>
                {["Name","Email","Phone"].map((item, i) => (
                  <tr key={i}>
                    <td>{item}</td>
                    <td><Form.Control /></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {/* ================= CHILD PAGES ================= */}
        {view === "web" && <WebTranslations onBack={() => setView("list")} />}
        {view === "app" && <AppTranslations onBack={() => setView("list")} />}
        {view === "admin" && <AdminTranslations onBack={() => setView("list")} />}

      </div>

      {/* ================= DELETE MODAL ================= */}
      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Language</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete{" "}
          <strong>{selectedLang?.name}</strong>?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDelete(false)}>
            Cancel
          </Button>

          <Button
            className="btn-orange"
            onClick={() => {
              alert("Deleted (demo)");
              setShowDelete(false);
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <style>
          {
               `
               .section-border {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 6px;
  background: #fff;
}

.flag-icon {
  width: 22px;
  height: 15px;
  border-radius: 3px;
}

.language-table th {
  background: #f4f6f9;
  font-weight: 600;
}

.btn-orange {
  background: #ff6a00;
  color: #fff;
  border: none;
}

/* PROGRESS RING */
.progress-ring-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3;
}

.progress-fill {
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: center;
}
  /* ACTION BUTTONS FIX */
.action-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;   /* 🔥 IMPORTANT */
  white-space: nowrap; /* 🔥 IMPORTANT */
}

/* ICON BUTTON */
.icon-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* TABLE SCROLL FIX */
.language-table {
  min-width: 1000px; /* 🔥 forces horizontal scroll */
}

/* SCROLL CONTAINER */
.table-responsive {
  overflow-x: auto !important;
}

/* MOBILE */
@media (max-width: 768px) {
  .language-table {
    min-width: 900px;
  }
}

.progress-en { stroke: #f59e0b; }
.progress-ar { stroke: #a855f7; }
.progress-de { stroke: #06b6d4; }
.progress-fr { stroke: #ef4444; }

/* MOBILE */
@media (max-width: 768px) {
  .language-table {
    font-size: 12px;
  }
}`
          }
      </style>
    </div>
  );
};

export default Language;